/* eslint-disable import/prefer-default-export */
/**
 * @param {BidProfile.IScheduleTemplateItem[]} workplans
 * @returns
 */
export default function formatWorkplanSchedulePatternResponse(workplans) {
    const selectedWorkplans = [];
    const workplanItems = [];

    for (const item of workplans) {
        if (item.workplanId) {
            let workplanFound = workplanItems.find((workplan) => workplan.workplanId === item.workplanId);
            if (!workplanFound) {
                selectedWorkplans.push(item.workplanId);

                const newWorkplanItem = {
                    name: item.workplanName,
                    workplanId: item.workplanId,
                    scheduleTemplates: {
                        items: [],
                    },
                };

                workplanFound = newWorkplanItem;
                workplanItems.push(workplanFound);
            }

            workplanFound.scheduleTemplates.items.push(item);
        }
    }

    return { selectedWorkplans, workplanItems };
}
